import React from 'react'
import PropTypes from 'prop-types'

import EventAttachmentsItem from 'components/Events/EventForm/EventAttachments/EventAttachmentsItem/EventAttachmentsItem'
import LoadingIndicator from 'components/LoadingIndicator'

import './event-attachments-list.pcss'

class EventAttachmentsList extends React.PureComponent {
    render () {
        const { attachments, onRemove, displayLoadingItem } = this.props

        return (
            <div className="event-attachments-list">
                {attachments.map((attachment, i) => (
                    <EventAttachmentsItem
                        key={attachment.id}
                        attachment={attachment}
                        onRemove={() => onRemove(attachment)}
                    />
                ))}
                {displayLoadingItem && (
                    <div className="event-attachments-list__loading-item">
                        <LoadingIndicator size="s" type="plain" />
                    </div>
                )}
            </div>
        )
    }
}

EventAttachmentsList.propTypes = {
    attachments: PropTypes.arrayOf(PropTypes.shape(
        {
            id: PropTypes.string.isRequired,
            filename: PropTypes.string.isRequired,
            mediatype: PropTypes.string.isRequired,
            attachmentUrl: PropTypes.string.isRequired,
            thumbUrl: PropTypes.string,
        }
    )),
    onRemove: PropTypes.func.isRequired,
    displayLoadingItem: PropTypes.bool,
}

export default EventAttachmentsList
